export const MAX_NON_EXPANDABLE_LIST_LENGTH = 5;
